import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiRoutes } from "src/app/config/api-routes";
import { AddIssueRequest } from "../model/addIssueRequest.model";
import { AddJobRequest } from "../model/addJobRequest.model";

@Injectable()
export class IssueService {

    constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}


    public createIssue(issue: AddIssueRequest){

        var formData: FormData =  new FormData();
        for ( var key in issue ) {
            if(key == "job"){
                for (let jobKey in issue.job) {
                    formData.append(`job[${jobKey}]`, issue[key][jobKey]);
                }            
            }else{
                formData.append(key, issue[key]);
            }
        }

        if(issue.files){
            issue.files.forEach(file => {
                formData.append('files', file, file.name);
            })
        }

        return this.httpClient.post(this.apiRoutes.ADD_ISSUE, formData)
    }
}